import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

// global imports
import { companyStore, externalStore, userStore } from "../../store/Store";
import useGetFetch from "../../hooks/useGetFetch";
import DisplayList from "../../components/DisplayList";
import Loading from "../../components/Loading";
import ErrorDisplay from "../../components/ErrorDisplay";

export default function CarrierDrivers() {
  // global
  const JwtToken = userStore((data) => data.JwtToken);
  const setAuthStatus = userStore((data) => data.setAuthStatus);
  const carrierDrivers = companyStore((data) => data.carrierDrivers);
  const setCarrierDrivers = companyStore((data) => data.setCarrierDrivers);
  const setPcCarrierDrivers = externalStore((data) => data.setPcCarrierDrivers);

  // local
  const [pending, setPending] = useState(false);
  const [statusCode, setStatusCode] = useState(200);
  const [error, setError] = useState(null);
  const [carrier, setCarrier] = useState();
  const [trigger, setTrigger] = useState(false);
  const { id } = useParams();
  const navigate = useNavigate();

  // get carrier and drivers
  const {
    isPending,
    error: carrierError,
    statusCode: carrierCode,
  } = useGetFetch(
    `${process.env.REACT_APP_BACKEND}/pc/company-carriers/${id}`,
    setCarrier
  );
  useEffect(() => {
    if (JwtToken === "") {
      navigate("/login");
      return;
    }
    const controller = new AbortController();
    setPending(true);
    const headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Authorization", "Bearer " + JwtToken);
    const ro = {
      method: "GET",
      headers,
      signal: controller.signal,
    };
    fetch(`${process.env.REACT_APP_BACKEND}/pc/carrier-drivers/${id}`, ro)
      .then((response) => {
        if (!response.ok) {
          if (response.status === 401) {
            navigate("/login");
            setAuthStatus(false);
            return;
          } else {
            setStatusCode(response.status);
            setError("Something went wrong");
            return Promise.resolve();
          }
        }
        return response.json();
      })
      .then((data) => {
        if (!data) {
          return;
        } else {
          setPending(false);
          setCarrierDrivers(data.carrier_drivers);
          setPcCarrierDrivers(data.pc_carrier_drivers);
        }
      })
      .catch((err) => {
        if (err.name === "AbortError") {
          console.log("The fetch was aborted");
          setPending(false);
          return;
        } else {
          console.log(err);
          setPending(false);
          setError("Could not load the Data");
        }
      })
      .finally(() => setPending(false));
    return () => {
      controller.abort();
    };
  }, [
    JwtToken,
    navigate,
    id,
    setCarrierDrivers,
    setPcCarrierDrivers,
    setAuthStatus,
  ]);

  if (isPending || pending) {
    return <Loading />;
  } else if (carrierError) {
    return <ErrorDisplay message={carrierError} code={carrierCode} />;
  } else if (error) {
    return <ErrorDisplay message={error} code={statusCode} />;
  }
  return (
    <div className="container-fluid">
      <DisplayList
        coll={"Carrier Drivers"}
        docs={carrierDrivers}
        trigger={trigger}
        setTrigger={setTrigger}
        setState={setCarrierDrivers}
        collectionName={carrier.carrier_name}
        statusToggle={true}
      />
    </div>
  );
}
